import React, { Component, Fragment } from 'react'
import Helmet from 'react-helmet'
// contents
import Hero from '../content/home/Hero'
import About from '../content/home/About'
import Facilites from '../content/home/Facilites'
import StragicLovation from '../content/home/StratgicLocation'
import Stories from '../content/home/Stories'
import Materials from '../content/home/Materials'
import Gallery from '../content/home/Gallery'
// partials
import Whatsapp from '../partials/stiky/WhatsApp'

class Home extends Component {
    render() {
        return (
            <Fragment>
                <Helmet>
                    <link rel="canonical" href="/" />
                    <link rel='shortlink' href='/' />
                    {/* Primary Meta Tags */}
                    <title>Home - Permata Puri Cibubur</title>
                    <meta name="title" content="Home - Permata Puri Cibubur"/>
                    <meta name="description" content="Permata Puri Cibubur merupakan hunian bernuansa di Cibubur. Persembahan terbaru dari Developer BUMN, PP Properti"/>
                    <meta name="keywords" content="Permata puri cibubur, puri cibubur, pp properti, tropical house, perumahan di cibubur, beli rumah di cibubur"/>

                    <meta itemprop="title" content="Home - Permata Puri Cibubur"/>
                    <meta itemprop="description" content="Permata Puri Cibubur merupakan hunian bernuansa di Cibubur. Persembahan terbaru dari Developer BUMN, PP Properti"/>
                    <meta itemprop="image" content="#"/>

                    {/* Open Graph / Facebook */}
                    <meta property="og:type" content="website"/>
                    <meta property="og:url" content="#"/>
                    <meta property="og:title" content="Home - Permata Puri Cibubur"/>
                    <meta property="og:description" content="Permata Puri Cibubur merupakan hunian bernuansa di Cibubur. Persembahan terbaru dari Developer BUMN, PP Properti"/>
                    <meta property="og:image" content="#"/>

                    {/* Twitter */}
                    <meta property="twitter:card" content="summary_large_image"/>
                    <meta property="twitter:url" content="#"/>
                    <meta property="twitter:title" content="Home - Permata Puri Cibubur"/>
                    <meta property="twitter:description" content="Permata Puri Cibubur merupakan hunian bernuansa di Cibubur. Persembahan terbaru dari Developer BUMN, PP Properti"/>
                    <meta property="twitter:image" content="#"/>
                    
                    <meta name="robots" content="index, follow"/>
                    <meta name="googlebot" content="index, follow"/>
                    <meta name="googlebot-news" content="index, follow"/>
                </Helmet>
                <Whatsapp/>
                <Hero/>
                <About/>
                <Facilites/>
                <StragicLovation/>
                <Stories/>
                <Materials/>
                <Gallery/>
            </Fragment>
        );
    }
}

export default Home;